// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__yNKXj","content":"layout_content__wSshz"};